const GET_ALL_CASHIER_OPERATION_TYPE = "GET_ALL_CASHIER_OPERATION_TYPE";

module.exports = {
    GET_ALL_CASHIER_OPERATION_TYPE,
}
